import { ReactNode } from "react";
import styles from "./Spinner.module.css";

export function Spinner(): ReactNode {
  return <div className={styles.Spinner} />;
}
